'use strict';

module.exports = function unwrap(value) {
  if (value instanceof this.constructor) {
    return value.all();
  }

  return value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/unwrap.js
// module id = ./node_modules/collect.js/dist/methods/unwrap.js
// module chunks = 0